import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { InfoDialogComponent } from 'src/app/components/common/info-dialog/info-dialog.component';
import { YesNoDialogComponent } from 'src/app/components/common/yes-no-dialog/yes-no-dialog.component';
import { MongoService } from 'src/app/services/mongo.service';
import { NavigatorService } from 'src/app/services/navigator.service';
import { AppState, StateService } from 'src/app/services/state.service';
import { UserDataService } from 'src/app/services/user-data.service';
import { UserOrdersService } from 'src/app/services/user-orders.service';

@Component({
  selector: 'user-edit-view',
  templateUrl: './user-edit-view.component.html',
  styleUrl: './user-edit-view.component.css'
})
export class UserEditViewComponent {

  voivodeships: string[] = [
    'Dolnośląskie',
    'Kujawsko-Pomorskie',
    'Lubelskie',
    'Lubuskie',
    'Łódzkie',
    'Małopolskie',
    'Mazowieckie',
    'Opolskie',
    'Podkarpackie',
    'Podlaskie',
    'Pomorskie',
    'Śląskie',
    'Świętokrzyskie',
    'Warmińsko-mazurskie',
    'Wielkopolskie',
    'Zachodniopomorskie'
  ];
  
  isSpinnerVisible: boolean = false;
  userData: any;
  pointsTotal: number = 0;
  rankingData: any;
  state: AppState = 'state-neutral';
  // Czy edytowany użytkownik ma złożone zamówienie w bieżącej kampanii — steruje
  // widocznością przycisku "ZAMÓWIENIE" obok adresu email.
  hasPlacedOrder: boolean = false;

  get registeredProducts(): any[] {
    const state = this.stateService.getState();
  
    if(state === 'state-pumps') {
      return this.userData.pumpRegisteredProducts || [];
    } 
    else if(state === 'state-airconditioners') {
      return this.userData.airConditionRegisteredProducts || [];
    } 
    else {
      return [];
    }
  }

  constructor(
    private route: ActivatedRoute,
    private navigator: NavigatorService,
    private mongoService: MongoService,
    private dialog: MatDialog,
    public userDataService: UserDataService,
    public stateService: StateService,
    private userOrdersService: UserOrdersService
  ) {}

  async ngOnInit(): Promise<void> {
    this.isSpinnerVisible = true;
    this.userData = await this.getSelectedUserData();
    this.rankingData = await this.userDataService.getUserRankingAndCount(this.userData);
    this.hasPlacedOrder = await this.checkUserPlacedOrder();
    this.countPointsTotal();
    this.isSpinnerVisible = false;
  }

  // Sprawdza, czy edytowany użytkownik ma zamówienie w bieżącej kampanii.
  private async checkUserPlacedOrder(): Promise<boolean> {
    const order = await this.userOrdersService.getCurrentCampaignOrderByEmail(this.userData?.userEmail);
    return !!order;
  }

  // Przekierowanie do widoku zamówienia tego użytkownika (tryb admina — email w URL).
  public redirectToUserOrder(): void {
    this.navigator.redirectToUserOrderScreen(this.userData?.userEmail);
  }

  private async getSelectedUserData() : Promise<any> {
    const userEmail = this.obtainUserIdFromQueryParameter();
    const userData = await this.mongoService.getUserDataByEmail(userEmail);
    if (userData) {
      return userData;
    }
    throw new Error("Couldn't find userDat.");
  }

  private obtainUserIdFromQueryParameter() : string {
    let userEmail: string = '';
    this.route.queryParams
      .subscribe(parameters => {
        userEmail = parameters.userEmail;
      });
    return userEmail;
  }
  
  async executeSaveChanges() : Promise<void> {
    this.isSpinnerVisible = true;
    let result = await this.mongoService.updateUserData(this.userData);
    this.isSpinnerVisible = false;
    if(result.status == 200){
      this.showSuccessDialog();
    } else {
      this.showErrorDialog();
    }
  }

  private showSuccessDialog() : void {
    this.dialog.open(InfoDialogComponent, { disableClose: true, data: {
      title: 'Sukces',
      message: 'Zamiany zostaly zapisane.',
      isErrorInfo: false,
      okFunc: null
    } });
  }

  private showErrorDialog() : void {
    this.dialog.open(InfoDialogComponent, { disableClose: true, data: {
      title: 'Błąd',
      message: "Wystąpił błąd podczas zapisu. Jeżeli problem się powtarza skontaktuj się z administratorem",
      isErrorInfo: true,
      okFunc: null
    } });
  }

  public redirectToUsersScreen() : void {
    this.navigator.redirectToUsersManagementScreen();
  }

  countPointsTotal(){
    if(this.stateService.getState() == 'state-pumps'){
      this.userData?.pumpRegisteredProducts?.forEach((product: any) => {
        this.pointsTotal += product.score;
      });
    } else if (this.stateService.getState() == 'state-airconditioners'){
      this.userData?.airConditionRegisteredProducts?.forEach((product: any) => {
        this.pointsTotal += product.score;
      });
    }
  }
}
